import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  getStatsHistorySalaryByBranchesExpDomainQuery,
  getStatsHistorySalaryByPersonIdQuery,
} from "./queries";
import { QUERY_STATUS } from "constants/constants";
import { useUserContext } from "api/user/UserProvider";

const SalariesDatatrackContext = createContext({});

export const useSalariesDatatrackContext = () =>
  useContext(SalariesDatatrackContext);

export const SalariesDatatrackProvider = ({ ...props }) => {
  const [statsHistorySalaryByBranches, setStatsHistorySalaryByBranches] =
    useState([]);
  const [salaryCoefPosWarning, setSalaryCoefPosWarning] = useState({});
  const [
    statsHistorySalaryByBranchesStatus,
    setStatsHistorySalaryByBranchesStatus,
  ] = useState(QUERY_STATUS.INITIAL);
  const [statsHistorySalaryByPersonId, setStatsHistorySalaryByPersonId] =
    useState([]);
  const [
    statsHistorySalaryByPersonIdStatus,
    setStatsHistorySalaryByPersonIdStatus,
  ] = useState(QUERY_STATUS.INITIAL);
  const { userScope } = useUserContext();

  const getStatsHistorySalaryByBranchesExpDomain = useCallback(
    async ({ experience, domain_ids, branch_ids }) => {
      try {
        setStatsHistorySalaryByBranchesStatus(QUERY_STATUS.LOADING);
        const result = await getStatsHistorySalaryByBranchesExpDomainQuery({
          experience,
          domain_ids,
          branch_ids,
        });
        setStatsHistorySalaryByBranches(result);
        setStatsHistorySalaryByBranchesStatus(QUERY_STATUS.SUCCESS);
      } catch (e) {
        setStatsHistorySalaryByBranchesStatus(QUERY_STATUS.ERROR);
        console.error("statsHistorySalaryByBranchesGetter", e);
        throw e;
      }
    },
    [statsHistorySalaryByBranches]
  );
  const getStatsHistorySalaryByPersonId = useCallback(
    async ({ id, experience, branch_id }) => {
      try {
        setStatsHistorySalaryByPersonIdStatus(QUERY_STATUS.LOADING);
        const result = await getStatsHistorySalaryByPersonIdQuery({
          id,
          experience,
          branch_id,
        });
        setStatsHistorySalaryByPersonId(result);
        setStatsHistorySalaryByPersonIdStatus(QUERY_STATUS.SUCCESS);
      } catch (e) {
        setStatsHistorySalaryByPersonIdStatus(QUERY_STATUS.ERROR);
        console.error("statsHistorySalaryByPersonIdGetter", e);
        throw e;
      }
    },
    [statsHistorySalaryByPersonId]
  );

  const getSalaryCoefPosWarning = useCallback(
    async ({ scope, salary, person_id }) => {
      try {
        const result = await getSalaryCoefPosWarning({
          scope,
          salary,
          person_id,
        });
        setSalaryCoefPosWarning(result);
        return result;
      } catch (e) {
        console.error("salaryCoefPosWarningError", e);
        throw e;
      }
    },
    [userScope]
  );

  const values = useMemo(
    () => ({
      getStatsHistorySalaryByBranchesExpDomain,
      setStatsHistorySalaryByBranches,
      statsHistorySalaryByBranches,
      getStatsHistorySalaryByPersonId,
      setStatsHistorySalaryByPersonId,
      statsHistorySalaryByPersonId,
      statsHistorySalaryByBranchesStatus,
      statsHistorySalaryByPersonIdStatus,
      setStatsHistorySalaryByBranchesStatus,
    }),
    [
      statsHistorySalaryByBranches,
      statsHistorySalaryByPersonId,
      statsHistorySalaryByBranchesStatus,
      statsHistorySalaryByPersonIdStatus,
      salaryCoefPosWarning,
    ]
  );

  return <SalariesDatatrackContext.Provider value={values} {...props} />;
};
